import { BROADCASTGROUP } from "@types/broadcastGroup";

export const BlankBroadcastGroupData: BROADCASTGROUP = {
  id: 0,
  name: "",
  code: "",
  tenant_id: 0,
  name_kana: "",
  parent: null,
};
